import { instBundle } from '@/axios.js';
const axiosAdmin2 = instBundle.axiosAdmin2;

export default {
	namespaced: true,
	state: {
		missionList: [],
		idRegister: null,
	},
	getters: {
		getMissionList(state) {
			return state.missionList;
		},
		getIdRegister(state) {
			return state.idRegister;
		},
	},
	mutations: {
		setMissionList(state, missionList) {
			state.missionList = missionList;
		},
		setIdRegister(state, idRegister) {
			state.idRegister = idRegister;
		},
	},
	actions: {
		async getMissionList({ state, commit }, idRegister) {
			try {
				if (idRegister) {
					commit('setIdRegister', idRegister);
				} else {
					idRegister = state.idRegister;
				}
				const { data } = await axiosAdmin2.get(
					`/api/registers/${idRegister}/event-mission`
				);
				commit('setMissionList', data.eventList);
				return data;
			} catch (error) {
				console.error(error);
				alert(
					'미션 목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
				);
				throw error;
			}
		},
	},
};
